import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import ProductList from "./product-list";
import AddProduct from "./add-product";
import EditProduct from "./edit-product";
import ProductAttributes from "./product-attributes";
import ProductEvents from "./product-events";
import PriceImport from "./price-import";

const PARENT_URL = "/cms/products";

const Products = () => {
  return (
    <Routes>
      <Route path={`/add-product`} element={<AddProduct />} />
      <Route path={`/edit-product/:id`} element={<EditProduct />} />
      <Route path={`/product-list`} element={<ProductList />} />
      <Route path={`/attributes`} element={<ProductAttributes />} />
      <Route path={`/product-events`} element={<ProductEvents />} />
      <Route path={`/price-import`} element={<PriceImport />} />
      <Route path={``} element={<Navigate to={`${PARENT_URL}/product-list`} replace />} />
    </Routes>
  );
};

export default Products;
